import React from 'react';
import { FiAlignLeft, FiType, FiCalendar, FiBox, FiImage, FiLayout, FiGrid, FiChevronsRight } from 'react-icons/fi';

// Shared per-component-type icon, used everywhere a layout component's type needs to be
// visually identifiable at a glance: the structure editor (LayoutStructureEditor.js,
// where a component's type is picked) and the value editor (TemplatePropertiesEditor.js,
// where content is filled in for that component). Colors for each type live alongside the
// corresponding CSS classes (.item-prop-type-badge--*, .item-prop--*, .gis-prop-card--*,
// .gis-prop-type-icon--*) in index.css / LayoutStructureEditor.js.
export const PROPERTY_TYPE_ICONS = {
  text: FiAlignLeft,
  line: FiType,
  date: FiCalendar,
  widget: FiBox,
  gallery: FiImage,
  poster: FiLayout,
  catalog: FiGrid,
  breadcrumbs: FiChevronsRight,
};

export function PropertyTypeIcon({ type, size = 11, className = '' }) {
  const Icon = PROPERTY_TYPE_ICONS[type] || FiType;
  return <Icon size={size} className={className} />;
}
